/**
 * Scroll-links hero overlay: --hero-scroll goes from 0 → 1 over SCROLL_RANGE px (page scroll).
 * Drives blur band height and gradient opacity in CSS.
 * --hero-img-parallax: vertical parallax offset (px) for the hero image.
 */
const SCROLL_RANGE = 500;
/** Image moves slower than scroll (subtle depth). */
const PARALLAX_FACTOR = 0.32;
/** Matches theme --small; scroll-linked hero vars disabled on narrow viewports. */
const MOBILE_MAX = "(max-width: 740px)";

export default function homeHeroScroll() {
    if (!document.body.classList.contains("home-template")) {
        return;
    }

    const hero = document.querySelector(".gh-home-hero");
    if (!hero) {
        return;
    }

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const narrow = window.matchMedia(MOBILE_MAX);

    let ticking = false;

    const update = () => {
        ticking = false;
        if (narrow.matches) {
            hero.style.removeProperty("--hero-scroll");
            hero.style.removeProperty("--hero-img-parallax");
            return;
        }

        const y = window.scrollY || window.pageYOffset;
        const t = Math.min(Math.max(y / SCROLL_RANGE, 0), 1);
        hero.style.setProperty("--hero-scroll", String(t));

        const parallaxPx = reduceMotion.matches ? 0 : y * PARALLAX_FACTOR;
        hero.style.setProperty("--hero-img-parallax", `${parallaxPx}px`);
    };

    const onScroll = () => {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
        }
    };

    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
}
